<template>
  <div id="merchant-page">
    <div class="flex items-center guidance-style py-2 px-4 mb-5">
      <feather-icon icon="AlertCircleIcon" svgClasses="h-6 w-6 text-blue-100" class="pr-5"/>
      <span class="ml-2 text-sm font-semibold">
        <p>
          {{$t('For help and guidance on how to pack your orders, check out our')}}
          <a target="_blank" :href="guidanceURL + `?lang=${$i18n.locale}`" class="text-blue-100 underline">{{$t('packaging Guidelines')}}</a> {{$t('our')}}
        </p>
      </span>
    </div>
    <div class="flex mb-6 sm:justify-start justify-center" style="border-bottom: 1px solid #C7C7C7;">
      <div :class="$route.query.tab === tab.value ? 'supplies-active-tab' : 'text-darkgray'" class="py-5 px-8 cursor-pointer" v-for="tab in tabs" :key="tab.index" @click="changeTabFilter(tab.value)">
        <p class="font-semibold leading-tight">{{$t(tab.name)}}</p>
      </div>
    </div>
    <div class="relative" v-if="activeTab === 0">
      <!-- SUPPLIES ITEMS -->
      <div class="supplies-items px-1" :style="isAndroid ? 'width: 100%' : 'width: calc(100% - 300px);'">
        <div class="page-title flex p-2 mb-5 gap-3">
          <div :class="$route.query.type === tab.value ? 'bg-primary text-white font-medium' : 'bg-white text-darkgray'" class="py-2 px-3 cursor-pointer rounded-md hover:shadow-drop"
            v-for="tab in statusFilters" :key="tab.index" @click="changeTabFilterSearch(tab.value)">
            <div class="text-sm">{{$t(tab.name)}}</div>
          </div>
        </div>

        <!-- FLYERS -->
        <div v-if="allFlag || flayerFlag">
          <p class="text-xl font-medium text-darkblue">{{$t('Flyers')}}</p>
          <div class="grid xl:grid-cols-4 lg:grid-cols-3 grid-cols-2 gap-4 mt-3 mb-2">
            <div v-for="(item, index) in packagesSize.filter(item => item.type === 'flyer')" :key="index">
              <div class="relative h-full supplies-card" :class="item.count === 0 ? '' : 'active-card'" :style="item.short_code === 'OSZ' ? 'display: none;' : ''">
                <div class="p-3 text-center supply-item">
                  <span class="size">{{item.short_code.split('-')[0]}}</span>
                  <img height="77" width="68" src="../../assets/images/pages/flyer.svg"/>
                </div>
                <div class="px-3 py-2">
                  <p v-if="item.unit_price > 0" class="text-primary text-sm font-medium">{{item.unit_price ? Number(item.unit_price).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' EGP': '0.00' + ' EGP'}}</p>
                  <p v-else class="text-primary text-sm font-medium">{{$t('Free')}}</p>
                  <div class="flex justify-between items-center gap-1 mt-1">
                    <div>
                      <p class="text-darkblue text-sm font-medium">{{item.name.split('(')[0]}}</p>
                      <p class="text-darkgray text-xs">{{item.name.split('(')[1] ? item.name.split('(')[1].slice(0, -1) : ''}}</p>
                    </div>
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-plus"
                      size="large"
                      class="supply-plus-button"
                      v-if="item.count === 0"
                      @click="addOne(item)"
                    >
                    </vs-button>
                    <vs-input-number v-else min="0" v-validate="'required|numeric'" :name="`quantity-f-${index}`" v-model.number="item.count" :value="0" class="input-shop" :class="errors.has(`quantity-f-${index}`) ? 'invalid' : ''"/>
                  </div>
                  <span class="text-danger text-sm hidden" v-show="errors.has(`quantity-f-${index}`)">{{ errors.first(`quantity-f-${index}`) ? errors.first(`quantity-f-${index}`).split(`-${index}`)[0] + errors.first(`quantity-f-${index}`).split(`-${index}`)[1]  : '' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- BOXES -->
        <div v-if="allFlag || bosxFlag">
          <p class="text-xl font-medium text-darkblue">{{$t('Boxes')}}</p>
          <div class="grid xl:grid-cols-4 lg:grid-cols-3 grid-cols-2 gap-4 mt-3 mb-6">
            <div v-for="(item, index) in packagesSize.filter(item => item.type === 'box')" :key="index">
              <div class="relative h-full supplies-card" :class="item.count === 0 ? '' : 'active-card'" :style="item.short_code === 'OSZ' ? 'display : none;' : ''">
                <div class="p-3 text-center supply-item">
                  <span class="size">{{item.short_code.split('-')[0]}}</span>
                  <img height="73" width="64" src="../../assets/images/pages/boxes.png"/>
                </div>
                <div class="px-3 py-2">
                  <p v-if="item.unit_price > 0" class="text-primary text-sm font-medium">{{item.unit_price ? Number(item.unit_price).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2}) + $t(' EGP'): '0.00' + $t(' EGP')}}</p>
                  <p v-else class="text-primary text-sm font-medium">{{$t('Free')}}</p>
                  <div class="flex justify-between items-center gap-1 mt-1">
                    <div>
                      <p class="text-darkblue text-sm font-medium">{{item.name.split('(')[0]}}</p>
                      <p class="text-darkgray text-xs">{{item.name.split('(')[1] ? item.name.split('(')[1].slice(0, -1) : ''}}</p>
                    </div>
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-plus"
                      size="large"
                      class="supply-plus-button"
                      v-if="item.count === 0"
                      @click="addOne(item)"
                    >
                    </vs-button>
                    <vs-input-number v-else min="0" v-validate="'required|numeric'" :name="`quantity-b-${index}`" v-model.number="item.count" :value="0" class="input-shop" :class="errors.has(`quantity-b-${index}`) ? 'invalid' : ''"/>
                  </div>
                  <span class="text-danger text-sm hidden" v-show="errors.has(`quantity-b-${index}`)">{{ errors.first(`quantity-b-${index}`) ? errors.first(`quantity-b-${index}`).split(`-${index}`)[0] + errors.first(`quantity-b-${index}`).split(`-${index}`)[1]  : '' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- OTHER ITEMS -->
        <div v-if="allFlag || otherFlag">
          <p class="text-xl font-medium text-darkblue">{{$t('Other Items')}}</p>
          <div class="grid xl:grid-cols-4 lg:grid-cols-3 grid-cols-2 gap-4 mt-3 md:mb-1 mb-6">
            <div v-for="(item, index) in packagesSize.filter(item => item.type === 'other')" :key="index">
              <div class="relative h-full supplies-card" :class="item.count === 0 ? '' : 'active-card'" :style="item.short_code === 'OSZ' ? 'display : none;' : ''">
                <div class="p-3 text-center supply-item">
                  <img height="73" :src="importImage(index)"/>
                </div>
                <div class="px-3 py-2">
                  <p v-if="item.unit_price > 0" class="text-primary text-sm font-medium">{{item.unit_price ? Number(item.unit_price).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2}) + $t(' EGP'): '0.00' + $t(' EGP')}}</p>
                  <p v-else class="text-primary text-sm font-medium">{{$t('Free')}}</p>
                  <div class="flex justify-between items-center gap-1 mt-1">
                    <div>
                      <p class="text-darkblue text-sm font-medium">{{item.name}}</p>
                      <p class="text-darkgray text-xs">{{item.description}}</p>
                    </div>
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-plus"
                      size="large"
                      class="supply-plus-button"
                      v-if="item.count === 0"
                      @click="addOne(item)"
                    >
                    </vs-button>
                    <vs-input-number v-else min="0" v-validate="'required|numeric'" :name="`quantity-o-${index}`" v-model.number="item.count" :value="0" class="input-shop" :class="errors.has(`quantity-o-${index}`) ? 'invalid' : ''"/>
                  </div>
                  <span class="text-danger text-sm hidden" v-show="errors.has(`quantity-o-${index}`)">{{ errors.first(`quantity-o-${index}`) ? errors.first(`quantity-o-${index}`).split(`-${index}`)[0] + errors.first(`quantity-o-${index}`).split(`-${index}`)[1]  : '' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- CART -->
      <div class="supplies-card checkout-cart" :class="!isAndroid ? 'h-full' : ''" :style="flag || !isAndroid ? 'height: 470px;' : 'height: 0px;'">
        <div class="relative h-full">
          <div :class="flag || !isAndroid ? 'block' : 'hidden'"> 
            <div class="py-3 px-4 mt-4 mx-4 mb-3 text-lg font-semibold text-black page-title flex justify-between items-center">
              <p class="font-semibold text-lg text-dark leading-tight">{{$t('Cart')}}</p>
              <feather-icon @click="flag = !flag" :class="isAndroid ? 'block cursor-pointer w-5 h-5 text-darkgray' : 'hidden'" icon="XSquareIcon" svgClasses="w-5 h-5"/>
            </div>
            <div v-if="packagesSize.filter(item => item.count > 0).length === 0" class="cart-body py-1 px-4 w-full">
              <div class="my-5 text-black text-center">
                <img height="182" width="182" src="../../assets/images/pages/supply-empty.gif"/>
                <p class="text-xl font-semibold">{{$t('Your cart is empty')}}</p>
                <p class="text-sm font-medium">{{$t('Add items to your cart')}}</p>
              </div>
            </div>
            <div v-else class="cart-body py-1 px-4 w-full">
              <div v-for="item in packagesSize.filter(item => item.count > 0)" :key="item.index">
                <div class="p-2 grid grid-cols-8 gap-2 justify-between mb-3 item">
                  <div class="flex items-center">
                    <img height="29" width="26" src="../../assets/images/pages/flyer.svg" v-if="item.type === 'flyer'"/>
                    <img height="29" width="26" src="../../assets/images/pages/boxes.png" v-if="item.type === 'box'"/>
                    <img height="29" width="26" src="../../assets/images/pages/other0.png" v-if="item.id === 9"/>
                    <img height="29" width="26" src="../../assets/images/pages/other1.png" v-if="item.id === 10"/>
                    <img height="29" width="26" src="../../assets/images/pages/other2.png" v-if="item.id === 11"/>
                    <img height="29" width="26" src="../../assets/images/pages/other3.png" v-if="item.id === 12"/>
                    <img height="29" width="26" src="../../assets/images/pages/other4.png" v-if="item.id === 13"/>
                  </div>
                  <div class="col-span-3">
                    <p class="text-sm" style="color: #1C5BFE!important;">{{item.name.split('(')[0]}}</p>
                    <p class="text-xs" >{{item.name.split('(')[1] ? item.name.split('(')[1].slice(0, -1) : ''}}</p>
                  </div>
                  <div class="items-center col-span-3 grid grid-cols-4">
                    <div class="col-span-2">
                      <p class="text-xs text-grey">{{$t('QTY')}}</p>
                      <p class="text-xs text-grey mt-1">{{$t('Price')}}</p>
                    </div>
                    <div class="col-span-2">
                      <p class="text-sm font-medium text-black">{{item.count}}</p>
                      <p class="text-sm font-medium text-black">{{item.unit_price === 0 ? $t('Free') : item.unit_price.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2})}}</p>
                    </div>
                  </div>
                  <feather-icon @click="removeSupply(item)" icon="Trash2Icon" svgClasses="w-6 h-8" class="cursor-pointer w-5 h-5 self-center text-red"/>
                </div>
              </div>
            </div>
          </div>
          <div @click="flag = !flag" class="total py-3 px-7 absolute bottom-0 w-full">
            <p class="text-darkblue font-semibold text-lg text-black">{{$t('Total')}}</p>
            <div class="flex items-center justify-between">
              <p class="text-black font-medium">{{(packagesSize.map(item => item.count).reduce((firstPackage, secondPackage) => Number(firstPackage) + Number(secondPackage), 0)).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2})}} {{$t('Item')}}</p>
              <p class="text-black">
                <span class="text-xl font-semibold">{{(packagesSize.map(item => item.count * item.unit_price).reduce((firstPackage, secondPackage) => firstPackage + secondPackage, 0)).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
                <span class="font-medium">{{' ' + $t('EGP')}}</span>
              </p>
            </div>
            <div class="mt-2" v-if="merchantStatus === 'active' && packagesSize.filter(item => item.count > 0).length > 0">
              <template v-if="merchant.name === 'Entrepreneur Merchant' && merchant.is_self_signup">
                <vx-tooltip position="top" color="warning" :text="`${$t('Your merchant profile is incomplete or still under review. You can still drop off your packages today!')}`">
                  <vs-button disabled="true" class="bg-blue-900 w-full" v-if="!isAndroid">{{$t('Check out')}}</vs-button>
                  <div v-else>
                    <vs-button class="bg-blue-900 w-full" :class="!flag ? 'block' : 'hidden'">{{$t('Check out')}}</vs-button>
                    <vs-button disabled="true" class="bg-blue-900 w-full" :class="flag ? 'block' : 'hidden'">{{$t('Confirm')}}</vs-button>
                  </div>
                </vx-tooltip>
              </template>
              <template v-else>
                <vs-button @click="supplyRequest()" class="bg-blue-900 w-full" v-if="!isAndroid">{{$t('Check out')}}</vs-button>
                <div v-else>
                  <vs-button class="bg-blue-900 w-full" :class="!flag ? 'block' : 'hidden'">{{$t('Check out')}}</vs-button>
                  <vs-button @click="supplyRequest()" class="bg-blue-900 w-full" :class="flag ? 'block' : 'hidden'">{{$t('Confirm')}}</vs-button>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <supplies-orders></supplies-orders>
    </div>
    <select-locations :selectLocationsModal="selectLocationsModal" @selectLocationsModal="selectLocationsModal = $event" @pickupPoint="pickupPoint = $event" @checkOut="checkOut"></select-locations>
    <success-massege :totalPrice="totalPrice" :successMassegeModal="successMassegeModal" @successMassegeModal="successMassegeModal = $event"></success-massege>
    <add-merchant-profile-info :addMerchantInfo="addMerchantInfo" @addMerchantInfo="addMerchantInfo = $event" @merchantUpdated="merchantUpdated = $event" @selected="selected = $event" />
  </div>
</template>

<script>
import {sendRequest} from '../../http/axios/requestHelper'
import ShipbluTable from '../../layouts/components/ShipBluTable.vue'
import ShipbluTr from '../../layouts/components/ShipBluTr.vue'
import ShipbluTh from '../../layouts/components/ShipBluTh.vue'
import ShipbluTd from '../../layouts/components/ShipBluTd.vue'
import SuppliesOrders from './SuppliesOrders.vue'
import SelectLocations from './SelectLocations.vue'
import successMassege from './successMassege.vue'
import i18nData from '../../i18n/i18nData'
import Other0 from '../../assets/images/pages/other0.png'
import Other1 from '../../assets/images/pages/other1.png'
import Other2 from '../../assets/images/pages/other2.png'
import Other3 from '../../assets/images/pages/other3.png'
import Other4 from '../../assets/images/pages/other4.png'
import common from '../../assets/utils/common'
import AddMerchantProfileInfo from './components/AddMerchantProfileInfo.vue'

export default {
  data () {
    return {
      windowWidth: 0,
      flag : false,
      totalPrice: 0,
      pickupPoint: {},
      statusFilters: [
        {
          name: 'All',
          value: ''
        },
        {
          name: 'Flyer',
          value: 'flyer'
        },
        {
          name: 'Boxes',
          value: 'box'
        },
        {
          name: 'Other Items',
          value: 'other'
        }
      ],
      Other0,
      Other1,
      Other2,
      Other3,
      Other4,
      tabs: [
        {
          name: 'Supplies Shop',
          value: 'supplies-shop'
        },
        {
          name: 'Supplies Orders',
          value: 'supplies-orders'
        }
      ],
      tabsDic: {'0': 'supplies-shop', '1': 'supplies-orders'},
      tabsNameDic: {'supplies-shop': 0, 'supplies-orders': 1},
      searchTab: ['All', 'Flyer', 'Box', 'other'],
      searchTabsDic: {'0': 'All', '1': 'Flyers', '2': 'box', '3': 'other'},
      activeTab: 0,
      searchActiveTab: 0,
      supplies: [],
      supply: {},
      packagesSize: [],
      packagesDic: {},
      successCount: 0,
      isAndroid: false,
      selectLocationsModal: false,
      successMassegeModal: false,
      typeFilter: '',
      summaryCashamount: '',
      allFlag: true,
      flayerFlag: false,
      bosxFlag: false,
      otherFlag: false,
      guidanceURL : 'https://shipblu.freshdesk.com/a/solutions/articles/80001044109',
      merchantStatus: '',
      merchant: {},
      addMerchantInfo: false,
      merchantUpdated: false

    }
  },
  watch: {
    '$route.params.lang' () {
      this.$router.push({
        name: `${this.$store.state.AppActiveUser.userRole}-supplies-shop`,
        query: {
          tab: this.tabsDic[this.activeTab],
          type: this.typeFilter,
          page: 1
        }
      }).catch(() => {})
    },
    windowWidth () {
      if (this.windowWidth < 768) {
        this.isAndroid = true
      } else {
        this.isAndroid = false
        this.flag = false
      }
    },
    'successCount' (val) {
      if (val === 5) {
        this.$vs.notify({
          color:'success',
          title:i18nData[this.$i18n.locale]['Success'],
          text: 'Supplies items have been updated successfully!',
          position: 'top-center'
        })
        this.activeTab = 1
      } 
    },
    '$route.query.tab' () {
      this.activeTab = this.tabsNameDic[this.$route.query.tab]
    },
    '$route.query' () {
      this.loadPackagesSize()
    },
    activeTab () {
      this.loadPackagesSize()
      this.$router.push({
        name: `${this.$store.state.AppActiveUser.userRole}-supplies-shop`,
        query: {
          tab: this.tabsDic[this.activeTab],
          type: this.typeFilter,
          page: 1
        }
      }).catch(() => {})
    },
    merchantUpdated () {
      const merchantData = common.checkMerchantInLocalStorage(this)
      merchantData.then(results => {
        this.merchant = results.merchantData
      })
    }
  },
  methods: {
    supplyRequest () {
      if (this.merchant.is_self_signup === true && this.merchant.name === 'Entrepreneur Merchant') {
        this.addMerchantInfo = true
      } else {
        this.selectLocationsModal = true
      }
    },
    addOne (supply) {
      supply.count = 0
      supply.count = supply.count + 1
    },
    importImage (index) {
      let image = ''
      switch (index) {
      case 0:
        image = this.Other0
        break
      case 1:
        image = this.Other1
        break
      case 2:
        image = this.Other2
        break
      case 3:
        image = this.Other3
        break
      case 4:
        image = this.Other4
        break
      default:
        break
      }
      return image
    },
    removeSupply (item) {
      item.count = 0
      const index = this.packagesSize.indexOf(item)
      if (index > -1) {
        this.packagesSize.splice(index, 1) 
      }
      this.packagesSize.splice(index, 0, item)
    },
    changeTabFilterSearch (type) {
      this.typeFilter = type
      this.$router.push({
        query: {
          tab: this.tabsDic[this.activeTab],
          page: this.activeTab,
          filter: this.filters,
          type: this.typeFilter
        }
      }).catch(() => {})
      this.loadPackagesSize()
    },
    changeTabFilter (tab) {
      this.activeTab = this.tabsNameDic[tab]
      this.$router.push({
        query: {
          tab: this.tabsDic[this.activeTab],
          page: this.activeTab,
          filter: this.filters,
          type: this.typeFilter
        }
      }).catch(() => {})
    },
    loadPackagesSize () {
      sendRequest(false, false, this, 'api/v1/package-sizes/', 'get', null, true,
        (response) => {
          const data = response.data.filter(item => item.id !== 9 && item.id !== 10)
          const time = new Date()
          const PackageSizesDataTime = {data, time}
          localStorage.setItem('packages', JSON.stringify(PackageSizesDataTime))
          this.managePackageSize(response.data.filter(item => item.id !== 9 && item.id !== 10))
          localStorage.setItem('cartItems', JSON.stringify(this.packagesSize))
          switch (this.typeFilter) {
          case '':
            this.allFlag = true
            this.flayerFlag = true
            this.bosxFlag = true
            this.otherFlag = true
            break
          case 'flyer':
            this.allFlag = false
            this.flayerFlag = true
            this.bosxFlag = false
            this.otherFlag = false
            break
          case 'box':
            this.allFlag = false
            this.flayerFlag = false
            this.bosxFlag = true
            this.otherFlag = false
            break
          case 'other':
            this.allFlag = false
            this.flayerFlag = false
            this.bosxFlag = false
            this.otherFlag = true
            break
          }
        }
      )
    },
    managePackageSize (packages) {
      if (localStorage.getItem('cartItems')) {
        this.packagesSize = JSON.parse(localStorage.getItem('cartItems'))
      } else {
        this.packagesSize = packages
        this.packagesSize.forEach(element => {
          element.count = 0
        })
      }
      this.packagesSize.forEach(packageSize => {
        this.packagesDic[packageSize.id] = packageSize.short_code
      })
    },
    checkOut () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const packages = []
          this.packagesSize.forEach(element => {
            packages.push({
              package_size: element.id,
              count: Number(element.count)  
            })
          })
          const dataSend = {
            supplies_items: packages.filter(item => item.count > 0),
            pickup_point : this.pickupPoint.id
          }
          this.totalPrice = this.packagesSize.map(item => item.count * item.unit_price).reduce((firstPackage, secondPackage) => firstPackage + secondPackage, 0)
          sendRequest(false, false, this, 'api/v1/supplies/', 'post', dataSend, true,
            () => {
              this.loadPackagesSize()
              this.selectLocationsModal = false
              this.packagesSize.forEach(element => {
                element.count = 0
              })
              localStorage.setItem('cartItems', JSON.stringify(this.packagesSize))
              this.$router.push({
                query: {
                  tab: 'supplies-orders',
                  page: 1
                }
              }).catch(() => {})
              this.$vs.notify({
                color:'success',
                title:i18nData[this.$i18n.locale]['Success'],
                text: 'Your Order has been confirmed',
                position: 'top-center'
              })
            }
          )
        }
      })
    },
    summaryCash () {
      sendRequest(true, false, this, 'api/v1/billing/statements/summary/', 'get', null, true,
        (response) => {
          this.summaryCashamount = response.data
        }
      )
    }
  },
  beforeDestroy () {
    localStorage.setItem('cartItems', JSON.stringify(this.packagesSize))
  },
  created () {
    localStorage.removeItem('cartItems')
    this.activeTab = this.$route.query.tab ? this.tabsNameDic[this.$route.query.tab] : '0'
    this.searchActiveTab = this.$route.query.type ? this.searchTabsDic[this.$route.query.tab] : '0'
    this.summaryCash()
    this.loadPackagesSize()
    this.windowWidth = window.innerWidth
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
    if (this.windowWidth < 768) {
      this.isAndroid = true
    } else {
      this.isAndroid = false
      this.flag = false
    }
    const merchantData = common.checkMerchantInLocalStorage(this)
    let user = {}
    merchantData.then(results => {
      user = results.merchantData
      this.merchantStatus = user.status
      this.merchant = user
    })
  },
  components: {
    ShipbluTable,
    ShipbluTr,
    ShipbluTh,
    ShipbluTd,
    SuppliesOrders,
    SelectLocations,
    successMassege,
    AddMerchantProfileInfo
  }
}
</script>

<style lang="scss">
.coming-soon {
  position: absolute;
  inset: 0;
  z-index: 999;
  background: rgba(157, 173, 194, 0.19);
  backdrop-filter: blur(2px);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    color: #FFFFFF;
    background: rgba(108, 132, 163, 0.72);
    backdrop-filter: blur(2px);
    border-radius: 8px;
    width: fit-content;
    padding: 12px 8px;
    font-weight: 600;
    font-size: 13px;
    text-transform: uppercase;
  }
}
.guidance-style {
  background: #EDF4FB;
}
.supplies-active-tab {
  background: #EDF4FB;
  color: #1C5BFE;
  border-radius: 8px 8px 0px 0px;
  border-bottom: 3px solid #1C5BFE;
}
.supplies-items {
  height: calc(100vh - 280px);
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
}
.supply-item {
  background: rgba(243, 249, 255, 0.68);
  border-radius: 10px 10px 0px 0px;
  .size {
    background: rgba(28, 91, 254, 0.09);
    border-radius: 5px;
    position: absolute;
    left: 10.5px;
    top: 10.5px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25px;
    height: 25px;
    color: #0A3266;
    font-weight: 600;
    font-size: 14px;
  }
}
.supply-plus-button{
  border-radius: 5px !important;
  background: #0A3266 !important;
  max-width: 30px;
  max-height: 30px;
}
.input-shop {
  position: relative;
  background: #FFFFFF;
  border: 1px solid #CACACA;
  border-radius: 5px;
  height: 25px;
  &.invalid {
    border: 1px solid #FE8383;
     input[type="number"]::-webkit-inner-spin-button {
      border-left: 1px solid #FE8383;
    }
  }
  .vs-input-number--input{
    width: 50px !important;
    font-size: .875rem !important;
  }
  .btn-less, .btn-plus{
    display: none;
  }
  &:before {
    content: "";
    position: absolute;
    bottom: 2px;
    right: 3px;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 7px solid #E5E5E5;
    pointer-events: none;
  }
  &:after {
    content: "";
    position: absolute;
    top: 2px;
    right: 3px;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 7px solid #E5E5E5;
    pointer-events: none;
  }
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    height: 25px;
    width: 12px;
    opacity: 1;
    border-left: 1px solid #d8d8d8;
    border-radius: 5px;
    cursor: pointer;
  }
}
.supplies-card {
  background: #FFFFFF;
  box-shadow: 0px 0px 4px rgba(131, 131, 131, 0.22);
  border-radius: 10px;
  border: 1px solid #F3F9FF;
}
.active-card{
  border: 1px solid #1C5BFE;
  box-shadow: 0px 0px 4px #1C5BFE;
}
.checkout-cart {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 280px;
  border-radius: 10px 10px 0px 0px;
  .cart-body {
    height: calc(100% - 175px);
    position: absolute;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .total {
    background: #F1F8FF;
    box-shadow: 0px -1px 6px rgba(0, 0, 0, 0.25);
    border-radius: 10px 10px 0px 0px;
  }
  .item {
    background: #FFFFFF;
    box-shadow: 1px 1px 4px rgba(28, 91, 254, 0.22);
    border-radius: 10px;
  }
}
@media (max-width: 767px) {
  .checkout-cart {
    top: unset;
    bottom: -117px;
    width: 100%;
    z-index: 2;
  }
  .supplies-items {
    height: calc(100vh - 390px);
  }
}
</style>